import Cookies from 'js-cookie';
import tokenManager from '../services/auth/tokenManager';
import {
  getCurrentBranchSlug,
  getCurrentClientSlug,
  getCurrentOrgSlug,
} from '../utils/tenant';
export let token;

//decodes jwt token
export function parseJwt(token) {
  if (!token) return null;

  try {
    const segments = token.split('.');
    if (segments.length < 2 || !segments[1]) {
      return null;
    }

    const base64 = segments[1].replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.warn('[auth] Failed to parse JWT payload', error);
    return null;
  }
}

//get stored token data - Cookie-only authentication
export const CheckAuth = () => {
  // NOTE: Cookie-only auth. Access tokens are HttpOnly cookies; JS cannot read them.
  const user = tokenManager.getUserData();

  // In cookie-mode, having a user object is our client-side signal.
  // Server remains the source of truth (401s if cookie invalid).
  if (user) {
    // Return data in the legacy format for compatibility
    const userData = {
      token: 'cookie-based-auth',  // placeholder for legacy callers
      user_id: user.userId || user.user_id || user.id,
      user_email: user.email || user.userEmail,
      first_name: user.firstName || user.first_name,
      last_name: user.lastName || user.last_name,
      pending_application_id: user.pendingApplicationId || user.pending_application_id,
      permissions: user.permissions || []
    };
    token = 'cookie-based-auth'; // Set module variable for compatibility
    return userData;
  }

  return null;
};

//get headers - Cookie-only authentication
export const getHeaders = () => {
  // NOTE: In cookie-only mode, we don't add Authorization headers.
  // Cookies are sent automatically with withCredentials: true
  const user = tokenManager.getUserData();

  const headers = {
    'Content-Type': 'application/json',
  };

  // Include CSRF token header when present (double-submit cookie strategy)
  const csrfToken = Cookies.get('csrf_token');
  if (csrfToken) {
    headers['X-CSRF-Token'] = csrfToken;
    headers['X-CSRFToken'] = csrfToken; // alternate header for compatibility
    headers['X-XSRF-TOKEN'] = csrfToken; // axios-style header for compatibility
  }

  const organizationId =
    user?.organization_id ||
    user?.organizationId ||
    user?.primary_organization_id ||
    user?.primaryOrganizationId;
  if (organizationId) {
    headers['X-Organization-Id'] = organizationId;
  }

  const clientSlugFromUser = user?.client_organization_slug || user?.clientOrganizationSlug;
  const branchSlugFromUser = user?.branch_slug || user?.branchSlug || user?.branch?.slug;
  let organizationSlug =
    clientSlugFromUser ||
    user?.organization_slug ||
    user?.organizationSlug ||
    getCurrentClientSlug() ||
    getCurrentOrgSlug();

  if (
    organizationSlug &&
    branchSlugFromUser &&
    organizationSlug === branchSlugFromUser &&
    clientSlugFromUser
  ) {
    organizationSlug = clientSlugFromUser;
  }

  if (organizationSlug) {
    headers['X-Tenant-Slug'] = organizationSlug;
  }

  const branchSlug = branchSlugFromUser || getCurrentBranchSlug();
  if (branchSlug) {
    headers['X-Branch-Slug'] = branchSlug;
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    headers['X-Tenant-Host'] = window.location.hostname;
  }

  return headers;
};

export const getExcelHeaders = () => {
  // NOTE: In cookie-only mode, we don't add Authorization headers.
  // Cookies are sent automatically with withCredentials: true
  const user = tokenManager.getUserData();

  const headers = {};

  const organizationId =
    user?.organization_id ||
    user?.organizationId ||
    user?.primary_organization_id ||
    user?.primaryOrganizationId;
  if (organizationId) {
    headers['X-Organization-Id'] = organizationId;
  }

  const clientSlugFromUser = user?.client_organization_slug || user?.clientOrganizationSlug;
  const branchSlugFromUser = user?.branch_slug || user?.branchSlug || user?.branch?.slug;
  let organizationSlug =
    clientSlugFromUser ||
    user?.organization_slug ||
    user?.organizationSlug ||
    getCurrentClientSlug() ||
    getCurrentOrgSlug();

  if (
    organizationSlug &&
    branchSlugFromUser &&
    organizationSlug === branchSlugFromUser &&
    clientSlugFromUser
  ) {
    organizationSlug = clientSlugFromUser;
  }

  if (organizationSlug) {
    headers['X-Tenant-Slug'] = organizationSlug;
  }

  const branchSlug = branchSlugFromUser || getCurrentBranchSlug();
  if (branchSlug) {
    headers['X-Branch-Slug'] = branchSlug;
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    headers['X-Tenant-Host'] = window.location.hostname;
  }

  return headers;
};

// userDetails function
export const getUserDetails = () => {
  const {
    user_id: userId,
    user_email: userEmail,
    first_name: firstName,
    last_name: lastName,
    pending_application_id: pendingApplicationId,
    token,
    permissions: permissions,
  } = CheckAuth() || {};
  return {
    userId,
    userEmail,
    firstName,
    lastName,
    pendingApplicationId,
    token,
    permissions,
  };
};
